import MockAdCreative from "./MockAdCreative";

export default function HeroDashboardMockup() {
  return (
    <div className="browser-mockup" data-testid="hero-dashboard-mockup">
      {/* Browser bar */}
      <div className="browser-bar">
        <div className="browser-dot bg-red-400" />
        <div className="browser-dot bg-yellow-400" />
        <div className="browser-dot bg-green-400" />
        <div className="flex-1 ml-3">
          <div className="bg-white rounded-md px-3 py-1.5 text-xs text-slate-400 max-w-xs border border-slate-200" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
            app.adbit.digital/analysis
          </div>
        </div>
      </div>

      {/* Dashboard content */}
      <div className="p-4 md:p-6 bg-slate-50/50">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {/* Left: Ad with heatmap */}
          <div className="md:col-span-2">
            <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
              <div className="px-3 py-2 border-b border-slate-100 flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-orange-500" />
                <span className="text-xs font-medium text-slate-500">Attention Heatmap</span>
              </div>
              <MockAdCreative showHeatmap={true} size="sm" />
            </div>
          </div>

          {/* Right: Scores dashboard */}
          <div className="md:col-span-3 flex flex-col gap-3">
            {/* Score cards row */}
            <div className="grid grid-cols-3 gap-3">
              <ScoreCard label="Attention Score" value="87" color="emerald" />
              <ScoreCard label="Brand Visibility" value="62" color="amber" />
              <ScoreCard label="Engagement" value="High" color="indigo" isText />
            </div>

            {/* Neuro Score card */}
            <div className="bg-white rounded-xl border border-slate-200 p-4">
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-medium text-slate-500">Ad Neuro Score</span>
                <span className="text-2xl font-bold text-orange-600" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
                  78<span className="text-sm text-slate-400">/100</span>
                </span>
              </div>
              <div className="space-y-2">
                <BarMetric label="Attention" value={87} />
                <BarMetric label="Clarity" value={72} />
                <BarMetric label="Emotion" value={81} />
                <BarMetric label="Brand" value={62} />
                <BarMetric label="Memory" value={75} />
                <BarMetric label="CTA" value={90} />
              </div>
            </div>

            {/* Recommendation snippet */}
            <div className="bg-white rounded-xl border border-slate-200 p-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 5v14M5 12h14"/>
                  </svg>
                </div>
                <div>
                  <p className="text-xs font-medium text-slate-700">Top Recommendation</p>
                  <p className="text-xs text-slate-500 mt-0.5">Move logo to lower-right zone to increase brand recall by ~25%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ScoreCard({ label, value, color, isText }) {
  const colorMap = {
    emerald: { bg: 'bg-emerald-50', text: 'text-emerald-600', bar: 'bg-emerald-500' },
    amber: { bg: 'bg-amber-50', text: 'text-amber-600', bar: 'bg-amber-500' },
    indigo: { bg: 'bg-orange-50', text: 'text-orange-600', bar: 'bg-orange-500' },
  };
  const c = colorMap[color];

  return (
    <div className={`${c.bg} rounded-xl p-3 border border-slate-100`}>
      <p className="text-[10px] font-medium text-slate-500 mb-1">{label}</p>
      <p className={`text-xl font-bold ${c.text}`} style={{ fontFamily: isText ? 'Outfit, sans-serif' : 'JetBrains Mono, monospace' }}>
        {value}
      </p>
    </div>
  );
}

function BarMetric({ label, value }) {
  const getColor = (v) => {
    if (v >= 80) return 'bg-emerald-500';
    if (v >= 60) return 'bg-amber-500';
    return 'bg-red-500';
  };

  return (
    <div className="flex items-center gap-3">
      <span className="text-[10px] font-medium text-slate-400 w-14">{label}</span>
      <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
        <div className={`h-full rounded-full ${getColor(value)}`} style={{ width: `${value}%` }} />
      </div>
      <span className="text-[10px] font-medium text-slate-500 w-6 text-right" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
        {value}
      </span>
    </div>
  );
}
